import type { GatsbyBrowser } from "gatsby"

const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  const polyfills: Promise<any>[] = []

  if (typeof fetch === "undefined") {
    polyfills.push(import("whatwg-fetch"))
  }

  if (typeof Intl === "undefined") {
    polyfills.push(import("intl").then(() => import("intl/locale-data/jsonp/fr.js")))
  }

  return Promise.all(polyfills)
}

export default onClientEntry
